import React, { Component } from "react";
import { Select } from "antd";
import "./style.css";

const { Option } = Select;

class IndustryElementSelector extends Component {
	select = (values) => {
		const { industries, onChange } = this.props;
		const updatedIndustries = industries.map((industry) => ({
			...industry,
			selected: values.includes(industry.id),
		}));
		onChange(updatedIndustries);
	};

	static defaultProps = {
		showSearch: false, // Set default value for showSearch prop
	};

	render() {
		const {
			industries,
			showSearch
		} = this.props;

		const selectedIndustries = industries.filter(
			(industry) => industry.selected
		);

		return (
			<div className="bl-industries-multi">
				<div className="bl-industries-multi-list">

					<Select
						className="fr-main-industries"
						showSearch={showSearch}
						mode="multiple"
						onChange={this.select}
						value={selectedIndustries.map((industry) => industry.id)}
						placeholder="Select industries"
					>
						{industries.map((industry) => (
							<Option
								key={industry.id}
								value={industry.id}
								className="rf-industry-item-button"
							>
								{industry.name}
							</Option>
						))}
					</Select>



				</div>
			</div>
		);
	}
}

export default IndustryElementSelector;
